import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
/* import 'vue-material-design-icons/styles.css' */
import './assets/postit-js.css'
import './assets/variables.css'
import vuetify from './plugins/vuetify'
import VueMoment from 'vue-moment';
import 'splitpanes/dist/splitpanes.css'
import i18n from './translate';
Vue.config.productionTip = false;
Vue.use(Vuetify);
Vue.use(VueMoment);

export default new Vuetify({
  theme: {
    primary: '#000000',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107',
  }
})
new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: h => h(App)
}).$mount('#app');

